import { baseHHASupervisory } from '../validations/hha-supervisory/v1';
const shape = baseHHASupervisory.shape;
export const hhaPresentField = [{ key: 'hhaPresent', field: shape.hhaPresent }];
export const evaluationFields = [
    { key: 'ptInterviewed', field: shape.ptInterviewed },
    { key: 'observedCare', field: shape.observedCare },
    { key: 'caringAttitude', field: shape.caringAttitude },
    { key: 'confidentiality', field: shape.confidentiality },
    { key: 'openCommunication', field: shape.openCommunication },
    { key: 'followHHAPOC', field: shape.followHHAPOC },
    { key: 'safeEffectiveCare', field: shape.safeEffectiveCare },
    { key: 'infectionPrevention', field: shape.infectionPrevention },
    { key: 'cleanEnvironment', field: shape.cleanEnvironment },
    { key: 'ptBenefittingHHAaid', field: shape.ptBenefittingHHAaid },
    { key: 'aidSameFrequency', field: shape.aidSameFrequency },
    { key: 'aidPlanUpdated', field: shape.aidPlanUpdated },
];
